import { Psychologist } from "../interfaces"

export const useMaxExperience = (psy: Psychologist) => {
    const experience = Math.max(psy.experience || 0, psy.private_experience || 0)
    return { experience }
}
